import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import SummaryCard from "components/SummaryCard/SummaryCard";
import { get } from "helpers/api_helper";
import { showErrorToast } from "helpers/toastMessages";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import * as api from "../../../constants/api_constants";

const ViewCandidateProgress = () => {
  const { candidateId } = useParams();
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [jobsDetails, setJobsDetails] = useState([]);
  const navigate = useNavigate();
 

  useEffect(() => {
    fetchCandidatesDetails();
  }, [candidateId]);

  const fetchCandidatesDetails = async () => {
    try {
      const response = await get(api.CANDIDATES_GET_BY_ID(candidateId));
      const jobs = response?.data?.job || [];
      setCandidateDetails(response?.data);
      setJobsDetails(jobs);
      console.log("response", response);
      console.log("jobs", jobs);
    } catch (error) {
      showErrorToast("Failed to fetch candidate details");
      console.error("Error fetching candidate details:", error);
    }
  };

  // Function to render status with icon
  // const renderStatusWithIcon = (status) => {
  //   switch (status) {
  //     case "Interview Scheduled":
  //     case "Selected for Interview":
  //       return (
  //         <span className="d-flex align-items-center">
  //           <i className="fas fa-check-circle text-success me-2"></i>
  //           {status}
  //         </span>
  //       );
  //     case "Rejected":
  //       return (
  //         <span className="d-flex align-items-center">
  //           <i className="fas fa-times-circle text-danger me-2"></i>
  //           {status}
  //         </span>
  //       );
  //     default:
  //       return <span>{status}</span>;
  //   }
  // };

  return (
    <div className="page-content">
      <PageSubHeader
        heading="View Candidate Progress"
        routePath="Home"
        pageName="Candidates / View Candidate Progress"
      />
      <Container fluid className="px-4 py-5">
        <Row className="px-4">
          <SummaryCard title="Candidate Overview">
            <Row className="m-3 mt-0">
              <Col md={6}>
                <p className="sub1">Candidate Name</p>
                <p className="main1">
                  {candidateDetails?.generalInfoCandidateDto?.firstName}{" "}
                  {candidateDetails?.generalInfoCandidateDto?.lastName || "N/A"}
                </p>
                <p className="sub1">Candidate ID</p>
                <p className="main1">{candidateDetails?.candidateId || "N/A"}</p>
                <p className="sub1">Job Role</p>
                <p className="main1">Frontend Developer</p>
                <p className="sub1">Working Status</p>
                <p className="main1">Not Working</p>
                <p className="sub1">Resume</p>
                <p className="main1" style={{ color: "#1E9EFB" }}>
                  <i
                    className="fa-solid fa-paperclip me-2"
                    style={{ transform: "rotate(-45deg)" }}
                    title="Attach"
                  ></i>
                  View Resume
                </p>
              </Col>
              <Col md={6}>
                <p className="sub1">Candidate Email</p>
                <p className="main1">
                  {candidateDetails?.generalInfoCandidateDto?.email || "N/A"}
                </p>
                <p className="sub1">Candidate Mobile Number</p>
                <p className="main1">
                  {candidateDetails?.generalInfoCandidateDto?.mobileNumber ||
                    "N/A"}
                </p>
                <p className="sub1">Years in Experience</p>
                <p className="main1">
                  {candidateDetails?.professionalDetailsDto?.totalExperience ||
                    "N/A"}
                </p>
                <p className="sub1">Notice Period</p>
                <p className="main1">
                  {candidateDetails?.professionalDetailsDto?.noticePeriod ||
                    "N/A"}
                </p>
              </Col>
            </Row>
          </SummaryCard>

          <Row className="ms-2 mt-3">
            <Col>
              <h4 style={{ color: "#222222" }}>Jobs Applied</h4>
            </Col>
          </Row>
          <Row>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table
                    className="table mb-0"
                    style={{
                      border: "1px solid #E5E7EB",
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <thead style={{ backgroundColor: "#F9FAFB" }}>
                      <tr>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Job ID
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Job Title
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Company
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Department
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Experience
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Location
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Submitted On
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            color: "#475467",
                            fontWeight: 600,
                            padding: "12px",
                          }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobsDetails.length > 0 ? (
                        jobsDetails.map((item, index) => (
                          <tr
                            key={index}
                            style={{ borderBottom: "1px solid #E5E7EB" }}
                          >
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.jobId || "N/A"}
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.jobTitle || "N/A"}
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.companyName || "N/A"}
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.department || item.Department || "N/A"}
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.experienceRequiredFrom }-{item.experienceRequiredTo } Years
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.jobLocation  || "N/A"}
                            </td>
                            <td style={{ padding: "12px", color: "#111827" }}>
                              {item.appliedDate || item.appliedDate || "N/A"}
                            </td>
                            <td style={{ padding: "12px" }}>
                              {/* {renderStatusWithIcon(item.status || item.Status)} */}
                            </td>
                            <td style={{ padding: "12px" }}>
                              <div className="d-flex gap-2">
                                <i
                                  className="fa-solid fa-eye action-icon"
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate(
                                      `/view-candidate-profile/${candidateDetails.id}`
                                    )
                                  }
                                ></i>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No jobs applied
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default ViewCandidateProgress;